// From https://medium.com/@faid.affandi/how-to-use-route-parameters-with-ngrx-store-and-angular-resolvers-1bc5ac9f226e

import { createSelector } from '@ngrx/store';
import { AppState } from '../store.types';

export const selectRouterState = (state: AppState) => state.router;

export const selectRouteParams = createSelector(selectRouterState, (routerState) => routerState?.state?.params);

export const selectRouteBoardId = createSelector(selectRouteParams, (params) => {
  return params && params['boardId'];
});

export const selectRouteOrganisationId = createSelector(
  selectRouteParams,
  (params) => params && params['organisationId']
);

export const selectIsAdminRoute = createSelector(selectRouterState, (routerState) => {
  const url = routerState?.state?.url;
  return url ? url.startsWith('/admin') : false;
});
